export default __webpack_public_path__ + "static/media/startTimer.2968a745.mp3";